<template>
  <div id="mb-rulette" class="mb-rulette" @click="cancelCheck()">
    <img
      v-if="startGameConfig.mainImage"
      @click="cancelCheck()"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setValue(startGameConfig.mainImage.pos.x, 0) + 'px',
        left: setValue(startGameConfig.mainImage.pos.y, 0) + 'px',
      }"
    />
    <img
      class="roulette-border-img"
      draggable="false"
      :src="require('./arrows.png')"
      :style="{
        position: 'absolute',
        zIndex: 2,
        width: 100 + '%',
        height: 100 + '%',
        top: 0 + '%',
        left: 0 + '%',
        transition: '.5s',
        transform: 'rotate(' + arrowRotate + 'deg)',
      }"
    />
    <img
      v-if="items.length > 0"
      @mousedown="mouseDown"
      @mouseup="mouseUp"
      @touchstart="touchStart"
      @touchend="touchEnd"
      @click="cancelCheck()"
      class="roulette-border-img"
      draggable="false"
      :src="setBorder()"
      :style="{
        position: 'absolute',
        zIndex: 2,
        width: 100 + '%',
        height: 100 + '%',
        top: 0 + '%',
        left: 0 + '%',
      }"
    />
    <div
      v-if="startGameConfig.rouletteType != 'rotate' && items.length > 0"
      :style="{
        position: 'absolute',
        top: 0,
        width: 'calc(1920px *.05)',
        left: 'calc(1920px/2 - 1920px *.025)',
        height: '50%',
        transformOrigin: '50% 100%',
        zIndex: 2,
        transform: 'rotate(' + rotateLight + 'deg)',
      }"
    >
      <div
        id="light-spinner"
        class="light-spinner"
        style="position: absolute; top: 6px; left: 24px; width: 32px; height: 32px; border-radius: 50%"
      ></div>
    </div>
    <svg
      :style="{
        position: 'absolute',
        top: startGameConfig.rouletteType == 'rotate' ? '-3%' : '-5%',
        left: '-5%',
      }"
      width="110%"
      height="110%"
      viewBox="0 0 70 70"
    >
      <defs>
        <filter id="inset-shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feComponentTransfer in="SourceAlpha">
            <feFuncA type="table" tableValues="1 0" />
          </feComponentTransfer>
          <feGaussianBlur stdDeviation="1" />
          <feOffset dx="0" dy="2" result="offsetblur" />
          <feFlood flood-color="rgb(20, 0, 0)" result="color" />
          <feComposite in2="offsetblur" operator="in" />
          <feComposite in2="SourceAlpha" operator="in" />
          <feMerge>
            <feMergeNode in="SourceGraphic" />
            <feMergeNode />
          </feMerge>
        </filter>
        <g v-for="(pathIt, pathIndex) in items" :key="'roulette-piece-' + pathIndex">
          <path :id="'p_0-' + pathIndex" :d="pathIt.path.line0" fill="#ddd" stroke="#ddd" />
          <path :id="'p_1-' + pathIndex" :d="pathIt.path.line1" fill="#ddd" stroke="#ddd" />
          <path :id="'p_2-' + pathIndex" :d="pathIt.path.line2" fill="#ddd" stroke="#ddd" />
        </g>
      </defs>
      <g
        class="rotate-circle"
        :style="{
          transform: 'rotate(' + rotateValue + 'deg)',
          position: 'absolute',
        }"
      >
        <path
          class="roulette-pieces"
          style="transition: 0.5s"
          :id="'roulette-path' + index"
          stroke-width="1"
          stroke="white"
          :d="el.path.main"
          v-for="(el, index) in items"
          :key="'roulette-piece-' + index"
          :fill="el.color"
        />
        <path
          class="roulette-pieces-border"
          :id="'roulette-path-border' + index"
          style="transition: 0.5s"
          stroke-width="1"
          stroke="white"
          :d="el.path.main"
          v-for="(el, index) in items"
          :key="'roulette--border-piece-' + index"
          fill="transparent"
        />
        <g v-for="(img, indexImg) in items" :key="'roulette-piece-img-' + indexImg">
          <image
            style="transition: 0.5s"
            v-if="img.img"
            :width="setSvgImgWidth(img.text)"
            :height="setSvgImgHeight(img.text)"
            :x="setSvgImgX(img.text)"
            :y="0"
            :href="giveMeImagePlease(img.img.src)"
            :style="[{ transform: 'rotate(' + img.radCenter + 'deg)' }, setSvgImgStyle(img.text)]"
          />
        </g>
        <text
          style="transition: 0.5s"
          :font-size="setTextSize()"
          class="roulette-pieces-text"
          v-for="(elem, index2) in items"
          :key="'roulette-piece-text-' + index2"
        >
          <textPath :xlink:href="'#p_0-' + index2" startOffset="50%" text-anchor="middle">
            {{ elem.text.line0 }}
          </textPath>
          <textPath :xlink:href="'#p_1-' + index2" startOffset="50%" text-anchor="middle">
            {{ elem.text.line1 }}
          </textPath>
          <textPath :xlink:href="'#p_2-' + index2" startOffset="50%" text-anchor="middle">
            {{ elem.text.line2 }}
          </textPath>
        </text>
      </g>
    </svg>
    <div class="roulet-center" v-if="items.length > 0">
      <img
        draggable="false"
        :src="require('./center.png')"
        :style="{
          position: 'absolute',
          zIndex: 2,
          width: 100 + '%',
          height: 100 + '%',
          top: 0 + '%',
          fontSize: '48px',
          left: 0 + '%',
        }"
      />
      <transition name="modal-fade">
        <p
          style="z-index: 3; color: white; font-weight: bold; padding: 12%"
          :style="startGameConfig.centerCustomStyle"
          v-if="showText && !startGameConfig.noTexts"
        >
          {{ actualEl.text.line0 }}<br v-if="actualEl.text.line1 != ''" />{{ actualEl.text.line1
          }}<br v-if="actualEl.text.line2 != ''" />{{ actualEl.text.line2 }}
        </p>
      </transition>
      <transition name="modal-fade">
        <div
          v-if="showText && actualImg"
          style="width: 80%; height: 80%; border-radius: 50%; position: absolute; top: 10%; left: 10%; z-index: 2"
          :style="startGameConfig.centerBoxCustomStyle"
        >
          <img
            style="width: 100%; height: 100%"
            v-if="showText && actualImg"
            :style="startGameConfig.centerImgCustomStyle"
            :src="giveMeImagePlease(actualImg)"
          />
        </div>
      </transition>
    </div>
    <div
      @mouseenter="
        hoverIcon = true;
        arrowRotate = 20;
      "
      @mouseleave="
        hoverIcon = false;
        arrowRotate = 0;
      "
      v-if="startGameConfig.rouletteType != 'rotate'"
      class="roulette-button"
      @click="spinLight()"
    >
      <img :src="require('./ruletka-off.png')" />
      <img v-if="hoverIcon || !canISpin" :src="require('./ruletka-on.png')" />
    </div>
    <div
      @mouseenter="
        hoverIconRight = true;
        arrowRotate = 20;
      "
      @mouseleave="
        hoverIconRight = false;
        arrowRotate = 0;
      "
      v-if="startGameConfig.rouletteType != 'rotate'"
      class="roulette-button-right"
      @click="spinLight()"
    >
      <img :src="require('./ruletka-off.png')" />
      <img v-if="hoverIconRight || !canISpin" :src="require('./ruletka-on.png')" />
    </div>
    <div
      @mouseenter="
        hoverIcon = true;
        arrowRotate = 20;
      "
      @mouseleave="
        hoverIcon = false;
        arrowRotate = 0;
      "
      v-if="startGameConfig.rouletteType == 'rotate'"
      class="roulette-button"
      @click="rotateMe()"
    >
      <img :src="require('./ruletka-off.png')" />
      <img v-if="hoverIcon || !canISpin" :src="require('./ruletka-on.png')" />
    </div>
    <div
      @mouseenter="
        hoverIconRight = true;
        arrowRotate = 20;
      "
      @mouseleave="
        hoverIconRight = false;
        arrowRotate = 0;
      "
      v-if="startGameConfig.rouletteType == 'rotate'"
      class="roulette-button-right"
      @click="rotateMe()"
    >
      <img :src="require('./ruletka-off.png')" />
      <img v-if="hoverIconRight || !canISpin" :src="require('./ruletka-on.png')" />
    </div>
    <!-- <div
      v-for="(el, index) in 5"
      :key="'roulette-piece-' + index"
      :style="{
        width: '20%',
        height: '30%',
        background: colors[index],
        position: 'absolute',
        top: 'calc(50% - 15%)',
        left: 'calc(50% - 15%)',
        transformOrigin: '50% 100%',
        borderRadius: '50%',
        transform: 'rotate(' + (360 / 5) * index + 'deg)',
        'clip-path': 'polygon(0% 0%, 100% 0%, 50% 100%)',
      }"
    ></div>-->
  </div>
</template>
<script>
import defaultMixin from '../../mixins/defaultMixin';
import { Howler } from 'howler';
export default {
  name: 'mb-rulette',
  components: {},
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      key: 0,
      arrowRotate: 0,
      hoverIcon: false,
      hoverIconRight: false,
      rotateLight: 0,
      position: {
        start: {
          x: 0,
          y: 0,
        },
        end: {
          x: 0,
          y: 0,
        },
      },
      showText: false,
      audio: null,
      audioShort: null,
      audioFinal: null,
      canIPlayASong: true,
      rotateValue: 0,
      canISpin: true,
      actualImg: null,
      actualEl: {
        text: '',
      },
      items: [],
      colors: [
        '#3cb44b',
        '#ffe119',
        '#4363d8',
        '#4363d8',
        '#911eb4',
        '#42d4f4',
        '#f032e6',
        '#bfef45',
        '#fabed4',
        '#dcbeff',
        '#9A6324',
        '#aaffc3',
      ],
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    setTextSize() {
      if (this.startGameConfig.piecesTextSize) {
        return this.startGameConfig.piecesTextSize + 'px';
      } else {
        return '2px';
      }
    },
    setSvgImgWidth(txt) {
      let width = 10;
      if (txt) {
        if (txt.line0) width = 9;
        if (txt.line1) width = 8;
        if (txt.line2) width = 5;
      }
      return width;
    },
    setSvgImgHeight(txt) {
      let height = 27;
      if (txt) {
        if (txt.line0) height = 32;
        if (txt.line1) height = 34;
        if (txt.line2) height = 37;
      }
      return height;
    },
    setSvgImgX(txt) {
      let x = 30;
      if (txt) {
        if (txt.line0) x = 30;
        if (txt.line1) x = 31;
        if (txt.line2) x = 32.5;
      }
      return x;
    },
    setSvgImgY(txt) {
      let y = 0;
      if (txt) {
        if (txt.line0) y = 0;
        if (txt.line1) y = 0;
        if (txt.line2) y = 0;
      }
      return y;
    },
    setSvgImgClipPath(w, h) {
      return 'circle(' + w / 2 + ' at ' + w / 2 + ' ' + h / 2 + ')';
    },
    setSvgImgStyle(txt) {
      let width = 10,
        height = 27,
        x = 30,
        y = 0;
      if (txt) {
        if (txt.line0) {
          width = 9;
          height = 32;
          x = 30.5;
        }
        if (txt.line1) {
          width = 8;
          height = 34;
          x = 31;
        }
        if (txt.line2) {
          width = 5;
          height = 37;
          x = 32.5;
        }
      }
      return {
        // width: width,
        // height: height,
        // x: x,
        // y: y,
        'transform-origin': '50% 50%',
        // 'clip-path': 'circle(' + width / 2 + 'px at center)',
      };
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    setBorder() {
      if (this.startGameConfig.rouletteType == 'rotate') {
        return require('./border.png');
      } else {
        return require('./border2.png');
      }
    },
    spinLight() {
      if (this.canISpin) {
        let key = this.key;
        this.canISpin = false;
        this.showText = false;
        let random = this.randomNumber(99, 20);
        // console.log(random);
        this.audioShort.play();
        for (let x = 0; x <= random; x++) {
          setTimeout(() => {
            if (key == this.key) {
              this.rotateLight = this.rotateLight + 12;
              if (this.rotateLight == 360) this.rotateLight = 0;
              if (x == random) {
                if (this.audioShort) this.audioShort.stop();
                if (this.audioFinal) this.audioFinal.play();
                this.checkDeg();
              }
            }
          }, 200 * x);
        }
      }
    },
    checkDeg() {
      let deg = this.rotateLight;
      let array = this.items;
      let itemIndex;
      this.items.forEach((itm, index) => {
        // console.log();
        if (itm.rad1 < itm.rad2) {
          if (deg >= itm.rad1 && deg < itm.rad2) {
            this.actualEl.text = itm.text;
            this.showText = true;
            itemIndex = index;
            if (itm.img) {
              this.actualImg = itm.img.src;
            }
          }
        } else if ((deg >= itm.rad1 && deg < 361) || (deg >= 0 && deg < itm.rad2)) {
          this.actualEl.text = itm.text;
          this.showText = true;
          itemIndex = index;
          if (itm.img) {
            this.actualImg = itm.img.src;
          }
        }
      });
      setTimeout(() => {
        if (this.items.length > 2) {
          this.items.splice(itemIndex, 1);
          this.prepareItems();
        }
        this.canISpin = true;
      }, 1500);
    },
    flatDeg(deg) {
      // console.log(deg);
      if (deg > 360) {
        let value = Math.floor(deg / 360);
        return deg - value * 360;
      }
      return deg;
    },
    touchStart(e) {
      this.position.start.x = e.targetTouches[0].clientX;
      this.position.start.y = e.targetTouches[0].clientY;
    },
    touchEnd(e) {
      // console.log(e);
      this.position.end.x = e.changedTouches[0].clientX;
      this.position.end.y = e.changedTouches[0].clientY;
      if (
        this.position.start.x - this.position.end.x < -500 ||
        this.position.start.y - this.position.end.y < -150 ||
        this.position.end.y - this.position.start.y < -150
      )
        this.rotateMe();
    },
    mouseDown(e) {
      this.position.start.x = e.clientX;
      this.position.start.y = e.clientY;
    },
    mouseUp(e) {
      this.position.end.x = e.clientX;
      this.position.end.y = e.clientY;
      if (
        this.position.start.x - this.position.end.x < -500 ||
        this.position.start.y - this.position.end.y < -150 ||
        this.position.end.y - this.position.start.y < -150
      )
        this.rotateMe();
    },
    prepareSound() {
      this.audio = new Howl({
        src: require('./spinEffectTrue.mp3'),
        autoplay: false,
        loop: false,
        volume: 1,
        onend: () => {
          this.canIPlayASong = true;
        },
        onstop: () => {
          this.canIPlayASong = true;
        },
        onplay: () => {
          this.canIPlayASong = false;
        },
      });
      this.audioShort = new Howl({
        src: require('./click.mp3'),
        autoplay: false,
        loop: true,
        volume: 0.1,
      });
      this.audioFinal = new Howl({
        src: require('./true.mp3'),
        autoplay: false,
        loop: false,
        volume: 1,
      });
    },
    prepareItems() {
      this.items.forEach((itm, index) => {
        itm.path = {};
        itm.path.main = this.getSectorPath(
          70 / 2,
          70 / 2,
          70,
          0 + (360 / this.items.length) * index,
          0 + (360 / this.items.length) * (index + 1),
          index
        );
        itm.path.line0 = this.getSectorPath(
          70 / 2,
          70 / 2,
          60,
          0 + (360 / this.items.length) * index,
          0 + (360 / this.items.length) * (index + 1)
        );
        itm.path.line1 = this.getSectorPath(
          70 / 2,
          70 / 2,
          55,
          0 + (360 / this.items.length) * index,
          0 + (360 / this.items.length) * (index + 1)
        );
        itm.path.line2 = this.getSectorPath(
          70 / 2,
          70 / 2,
          50,
          0 + (360 / this.items.length) * index,
          0 + (360 / this.items.length) * (index + 1)
        );
        itm.rad2 = 90 - (360 / this.items.length) * index;
        itm.rad1 = 90 - (360 / this.items.length) * (index + 1);
        if (itm.rad1 < 0) {
          itm.rad1 = 360 - itm.rad1 * -1;
        }
        if (itm.rad2 < 0) {
          itm.rad2 = 360 - itm.rad2 * -1;
        }
        itm.radCenter = this.getCenter(itm.rad1, itm.rad2);
        // console.log(itm.rad1 + ' : ' + itm.rad2);
      });
    },
    getCenter(rad1, rad2) {
      if (rad1 < rad2) {
        let center = (rad1 - rad2) * -1;
        center = rad1 + center / 2;
        return center;
      } else {
        let tmpRad1 = 360 + rad1;
        let center = (rad2 - tmpRad1) * -1;
        center = rad2 + center / 2;
        return center;
      }
    },
    init() {
      this.items = _.cloneDeep(this.startGameConfig.items);
      // console.log(this.items);
      if (this.items.length > 0) {
        this.prepareItems();
      }
      this.prepareSound();
    },
    startAudio() {
      this.audio.play();
    },
    stopAudio() {
      this.audio.stop();
    },
    rotateMe() {
      if (this.startGameConfig.rouletteType == 'rotate' && this.canISpin) {
        this.canISpin = false;
        this.showText = false;
        this.actualImg = null;
        let tmpDeg = 0;
        let randNumb = this.randomNumber(360, 360);
        this.rotateValue = this.rotateValue + randNumb;
        // console.log(randNumb);
        tmpDeg = this.flatDeg(this.rotateValue);
        tmpDeg = 360 - tmpDeg;
        // console.log(tmpDeg);
        if (this.canIPlayASong) {
          this.startAudio();
        }
        let svgPoint = document.getElementById('roulette-point');
        let actualPoint = {
          y: 1080,
          el: null,
        };

        setTimeout(() => {
          this.checkDegWithProp(tmpDeg);
        }, 5000);
      }
    },
    checkDegWithProp(deg) {
      let array = this.items;
      let itemIndex;
      this.items.forEach((itm, index) => {
        if (itm.rad1 < itm.rad2) {
          if (deg >= itm.rad1 && deg < itm.rad2) {
            this.actualEl.text = itm.text;
            this.showText = true;
            if (itm.img) {
              this.actualImg = itm.img.src;
            }
            itemIndex = index;
          }
        } else if ((deg >= itm.rad1 && deg < 361) || (deg >= 0 && deg < itm.rad2)) {
          this.actualEl.text = itm.text;
          this.showText = true;
          if (itm.img) {
            this.actualImg = itm.img.src;
          }
          itemIndex = index;
        }
      });
      setTimeout(() => {
        if (this.items.length > 2) {
          this.items.splice(itemIndex, 1);
          this.prepareItems();
        }
        this.canISpin = true;
      }, 1500);
      // console.log(itemIndex);
    },
    getSectorPath(x, y, outerDiameter, a1, a2, index) {
      // console.log(a1 + ' : ' + a2);
      const degtorad = Math.PI / 180;
      const halfOuterDiameter = outerDiameter / 2;
      const cr = halfOuterDiameter - 5;
      const cx1 = Math.cos(degtorad * a2) * cr + x;
      const cy1 = -Math.sin(degtorad * a2) * cr + y;
      const cx2 = Math.cos(degtorad * a1) * cr + x;
      const cy2 = -Math.sin(degtorad * a1) * cr + y;
      return 'M' + x + ' ' + y + ' ' + cx1 + ' ' + cy1 + ' A' + cr + ' ' + cr + ' 0 0 1 ' + cx2 + ' ' + cy2 + 'Z';
    },
    getSectorPathDef(x, y, outerDiameter, a1, a2) {
      const degtorad = Math.PI / 180;
      const halfOuterDiameter = outerDiameter / 2;
      const cr = halfOuterDiameter - 5;
      const cx1 = Math.cos(degtorad * a2) * cr + x;
      const cy1 = -Math.sin(degtorad * a2) * cr + y;
      const cx2 = Math.cos(degtorad * a1) * cr + x;
      const cy2 = -Math.sin(degtorad * a1) * cr + y;
      return 'M' + x + ' ' + y + ' ' + cx1 + ' ' + cy1 + ' A' + cr + ' ' + cr + ' 0 0 1 ' + cx2 + ' ' + cy2 + 'Z';
    },
    cancelCheck() {
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkGameAction() {},
    resetGameAction() {
      this.key += 1;
      // this.items = this.startGameConfig.items;
      if (this.audio) this.audio.stop();
      if (this.audioShort) this.audioShort.stop();
      if (this.audioFinal) this.audioFinal.stop();
      this.init();
      this.canISpin = true;
      this.rotateLight = 0;
      this.rotateValue = 0;
      this.actualEl = {
        text: '',
      };
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
  beforeDestroy() {
    Howler.stop();
    this.audio = null;
    this.audioShort = null;
    this.audioFinal = null;
  },
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-rulette
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  top: 0px
  .light-spinner
    animation: 5s 0s lightMe ease-in-out infinite
    background: white
    opacity: .8
  @keyframes lightMe
    0%
      box-shadow: 0px 10px 10px 0 rgba(255, 255, 255, 1), 0px -10px 10px 0 rgba(255, 255, 255, 1), 10px 0px 10px 0 rgba(255, 255, 255, 1), -10px 0px 10px 0 rgba(255, 255, 255, 1)
    50%
      box-shadow: 0px 10px 10px 0 rgba(255, 255, 255, 1), 0px -10px 10px 0 rgba(255, 255, 255, 1), 10px 0px 10px 0 rgba(255, 255, 255, 1), -10px 0px 10px 0 rgba(255, 255, 255, 1)
    100%
      box-shadow: 0px 10px 10px 0 rgba(255, 255, 255, 1), 0px -10px 10px 0 rgba(255, 255, 255, 1), 10px 0px 10px 0 rgba(255, 255, 255, 1), -10px 0px 10px 0 rgba(255, 255, 255, 1)
  .roulet-center
    position: absolute
    width: 450px
    height: 450px
    top: calc(50% - 225px)
    left: calc(50% - 225px)
    border-radius: 50%
    // background: #f2f2f2
    // filter: drop-shadow(12px 12px 25px rgba(0,0,0,0.5))
    // box-shadow: .5vh .5vh 2vh 0vh rgba(0,0,0,.5)
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
  .rotate-circle
    will-change: all
    // transition-timing-function: ease-in-out
    transition: 4.5s
    transform-origin: center
  .roulette-button
    position: absolute
    cursor: pointer
    transition: .5s
    top: calc(1080px/2 - 136px/2)
    left: 30px
    width: 306px
    height: 136px
    display: flex
    flex-direction: row
    align-items: center
    z-index: 3
    justify-content: center
  .roulette-button-right
    position: absolute
    cursor: pointer
    transition: .5s
    top: calc(1080px/2 - 136px/2)
    right: 30px
    width: 306px
    height: 136px
    display: flex
    flex-direction: row
    align-items: center
    z-index: 3
    justify-content: center
  .roulette-button, .roulette-button-right
    img
      position: absolute
      top: 0
      left: 0
.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .1s linear
.modal-fade-leave-to, .modal-fade-enter
  transform: scale(.5)
  opacity: 0
</style>
